export const NO_CURRENCY = 'no_currency'

export const MAX_CATEGORIES_DISPLAYED = 10
